import { getTime, addDays, startOfDay, subDays } from 'date-fns';
import { zonedTimeToUtc, utcToZonedTime } from 'date-fns-tz';

export const isDateError = (startDate?: number, dueDate?: number) => {
	if (startDate !== undefined && dueDate !== undefined) {
		return startDate > dueDate;
	}
	return false;
};

export const transformDates = ({
	startDate,
	dueDate,
}: {
	startDate?: number;
	dueDate?: number;
}) => {
	if (startDate !== undefined && dueDate !== undefined) {
		return { startDate, dueDate };
	}

	if (startDate !== undefined) {
		// No due date - default to showing the due date one week after the start date
		return {
			startDate,
			dueDate: getTime(
				zonedTimeToUtc(startOfDay(addDays(utcToZonedTime(new Date(startDate), 'utc'), 7)), 'utc'),
			),
		};
	}

	if (dueDate !== undefined) {
		// No start date - default to showing the start date once week before the due date
		return {
			startDate: getTime(
				zonedTimeToUtc(startOfDay(subDays(utcToZonedTime(new Date(dueDate), 'utc'), 7)), 'utc'),
			),
			dueDate,
		};
	}

	return { startDate, dueDate };
};
